import { useGetRowColors } from './hooks';
import { NestedTableDecomposeProps, NestedTableRenderProps } from './types';

export const decomposeNestedTable = ({
  src,
  color,
  depth = 0,
  render,
}: NestedTableDecomposeProps) => {
  const colorArr = useGetRowColors(depth, src.length, color);

  return src.map((row, i) => {
    const { id, row: rowComponent, nestedData } = row;

    // Leaf row (no nested data)
    if (!nestedData) {
      return render({
        value: rowComponent,
        isLeaf: true,
        path: `${id}`,
        color: colorArr[i],
      } as NestedTableRenderProps);
    }

    // Branch row (with nested data)
    return render({
      value: nestedData,
      path: `${id}`,
      row: rowComponent,
      color: colorArr[i],
    });
  });
};
